'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.atlasPrepopulationWidget = function (atlasModel) {
	return mmWidgets.each(this, function () {
		const self = this,
			fillInValues = function () {
				const values = atlasModel.getExportValues();

				self.find('[data-mm-export-parameter=title]').attr('placeholder', values.title).val(values.title);
				self.find('[data-mm-export-parameter=description]').attr('placeholder', values.description).val(values.description);
				self.find('[data-mm-export-parameter=slug]').attr('placeholder', values.slug).val(values.slug).trigger('checkForExists');
				if (values.gaClientCode) {
					self.find('[data-mm-export-parameter=gaClientCode]').val(values.gaClientCode);
				} else {
					self.find('[data-mm-export-parameter=gaClientCode]').val('');
				}

			},
			fields = self.find('[data-mm-export-parameter=slug]');
		fields.domElements.forEach(domElement =>  {
			domElement.addEventListener('change', function () {
				const current = domElement.value;
				domElement.value = atlasModel.sanitize(current);
				domElement.dispatchEvent(new Event('checkForExists', {bubbles: true}));
			});
		});
		self.on('show', function () {
			fillInValues();
		});
	});
};
